export enum ItemTypeEnum {
  TYPE_VEHICLE = 'App\\Models\\VehicleItem',
  TYPE_INSTRUMENT = 'App\\Models\\InstrumentItem',
}